import moment from 'moment'

// Shared eligibility rule for kuota tambahan display.
//
// Kuota tambahan reaches the profile cards two ways — the merged mydiesel_quotatambahanrecords
// total and the vehicle's own vehicleQuotaAddition — and neither carried an eligibility test, so
// a TIDAK LAYAK or TAMAT CUKAI JALAN vehicle displayed its full amount while the Kuota Semasa
// column beside it already showed 0. This module is the one place that decides.
//
// DISPLAY ONLY. Nothing here writes; the approval letters do their own filtering in
// getPrintableVehiclesByDeclarationGroup and are deliberately not routed through this.

const normalizeCode = (value) => (value ? String(value).trim().toUpperCase() : '')

/** 'layak' | 'tidaklayak' | 'semak' — mirrors the aeduoStatusKey computed on the cards. */
export const aeduoStatusKeyFromProfile = (registerForm) => {
  const registrationType = registerForm ? registerForm.registrationType : ''
  if (registrationType === 'individual' || registrationType === 'corporation') {
    return 'layak'
  }
  if (registrationType === 'company') {
    const ssmType = registerForm && registerForm.companySSMType ? String(registerForm.companySSMType).trim().toUpperCase() : ''
    if (!ssmType) {
      return 'semak'
    }
    if (ssmType === 'ROC') {
      return 'tidaklayak'
    }
    return 'layak'
  }
  return 'semak'
}

export const isAeduoVehicleByCode = (vehicle) => {
  const bodyCode = normalizeCode(vehicle && vehicle.vehicleBodyTypeCode)
  const modelCode = normalizeCode(vehicle && vehicle.vehicleModelTypeCode)
  return (bodyCode === 'PIC' || bodyCode === 'JIP') && modelCode === 'AE'
}

/** Road tax read off the date itself, not the cron-set flag — updateExpiredRoadTaxVehicles runs
 *  on a schedule, so vehicleRoadTaxPassedFlag lags. Same criterion the letters use, including
 *  treating a missing end date as expired. */
export const isRoadTaxDateValid = (vehicle) =>
  vehicle && vehicle.vehicleRoadTaxEndDate ? moment().isBefore(vehicle.vehicleRoadTaxEndDate) : false

/**
 * Whether a vehicle may display kuota tambahan at all.
 *
 * AEDuo rows are judged on their own gate: they are never vehicleActiveTickedFlag: true by
 * design (the LPA pulls them separately), so the ticked/body/model ladder would blank the whole
 * PSDN-SYKT lane. Profile LAYAK + valid road tax is the same test isAeduoQualified applies to
 * the Kuota Asas and Kuota Semasa columns.
 */
export const isQuotaTambahanEligible = (vehicle, registerForm) => {
  if (!vehicle) {
    return false
  }
  if (isAeduoVehicleByCode(vehicle)) {
    return aeduoStatusKeyFromProfile(registerForm) === 'layak' && isRoadTaxDateValid(vehicle)
  }
  if (!vehicle.vehicleValidBodyFlag || !vehicle.vehicleValidModelFlag) {
    return false
  }
  if (vehicle.vehicleRoadTaxPassedFlag) {
    return false
  }
  // Sekatan is deliberately stricter than getVehicleStatusValue, which does not test it: a
  // restricted vehicle still reads KENDERAAN LAYAK in the status column but carries no tambahan.
  if (vehicle.vehicleRestrictionFlag) {
    return false
  }
  if (!vehicle.vehicleActiveTickedFlag) {
    return false
  }
  return isRoadTaxDateValid(vehicle)
}



// WEBPACK FOOTER //
// ./src/views/mydiesel/quotaTambahanEligibility.js